import { ArrowLeft, CalendarDays, Copy, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '@/design-system';
import { useCompanyDetails } from '../company-details-context';
import { CompanyDetailsActions } from './CompanyDetailsActions';

/** Stable identity and access actions shared by every company detail section. */
export function CompanyDetailsHeader() {
  const { company, companyStatusPt, isPurged, staffUser, accessTokenLoading, handleAccessCompany } = useCompanyDetails();
  return <header className="shrink-0 border-b border-gray-200 bg-white p-4 md:p-6">
    <Link to="/companies" className="mb-3 inline-flex items-center gap-2 rounded-lg bg-primary/10 px-3 py-2 text-sm font-medium text-primary hover:bg-primary/15"><ArrowLeft size={16} />Voltar para empresas</Link>
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div className="min-w-0 flex-1">
        <h2 title={company.name} className="truncate text-lg font-semibold text-slate-900">{company.name}</h2>
        <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-sm text-gray-500">
          {company.document && <span>{company.documentType ?? 'Documento'}: {company.document}</span>}
          {company.email && <span className="break-all">{company.email}</span>}
          {(company.mobilePhone || company.phone) && <span>{company.mobilePhone || company.phone}</span>}
          <span className="inline-flex items-center gap-1.5"><CalendarDays size={14} />Cliente desde {new Date(company.createdAt).toLocaleDateString('pt-BR')}</span>
        </div>
        <div className="mt-3 flex flex-wrap items-center gap-2 text-xs">
          <span className={`rounded-full px-2.5 py-1 font-medium ${isPurged || company.deletedAt ? 'bg-amber-50 text-amber-700' : 'bg-emerald-50 text-emerald-700'}`}>{companyStatusPt(company)}</span>
          {company.gatewayProvider && <span className="rounded-full bg-slate-100 px-2.5 py-1 text-slate-600">{company.gatewayProvider}</span>}
          <span className="text-gray-500">{company.slug}</span>
          <Button variant="ghost" size="sm" title={company.id} aria-label="Copiar ID da empresa" onClick={() => {
            void navigator.clipboard.writeText(company.id).then(() => toast.success('ID copiado.')).catch(() => toast.error('Não foi possível copiar o ID.'));
          }}><Copy size={14} />ID da empresa</Button>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {(staffUser?.role === 'SUPERADMIN' || staffUser?.role === 'SUPPORT') && !isPurged && !company.deletedAt && <Button onClick={() => void handleAccessCompany()} isLoading={accessTokenLoading}><ExternalLink size={16} />Acessar empresa</Button>}
        <CompanyDetailsActions key={`${company.id}:${staffUser?.role ?? 'anonymous'}:${isPurged}:${!!company.deletedAt}`} />
      </div>
    </div>
  </header>;
}
